import PropTypes from 'prop-types'
import React from 'react'
import Input from 'components/Form/Input'
import Checkbox from 'components/Form/Checkbox'
import Textarea from 'components/Form/Textarea'
import Button from 'components/Button'
import classes from './NewCategory.scss'

import { guid } from 'helpers/index'

export const submitInputId = `submit-${guid()}`

export const NewCategory = (props) => (
  <form onSubmit={props.handleSubmit} className={classes['form']}>
    <input type='submit' id={submitInputId} className={classes.hidden} />

    <header className={classes['header']}>
      <div className={classes['header-title']}>
        Adding a New Category
      </div>
    </header>

    <fieldset>
      <Input label='Name' placeholder='name' {...props.fields.name} />
      <Textarea label='Description' placeholder='A quick description for the category.' {...props.fields.desc} />
      <Input label='Priority'
        subLabel='Lower numbers are shown first on the Pricelist.'
        placeholder='Priority'
        pattern='[0-9]+'
        type='tel'
        {...props.fields.priority}
      />

      <Checkbox label='Hidden?' {...props.fields.hidden} />
    </fieldset>

    <footer className={classes['footer']}>
      <Button element={'label'} htmlFor={submitInputId} stick options={['green', 'block']}>
        Create Category
      </Button>
    </footer>
  </form>
)

NewCategory.propTypes = {
  category: PropTypes.object.isRequired,
  onSubmit: PropTypes.func, // actual submit function
  handleSubmit: PropTypes.func.isRequired, // redux-form function
  fields: PropTypes.object.isRequired,
  submitting: PropTypes.bool.isRequired
}

export default NewCategory



// WEBPACK FOOTER //
// ./src/components/Categories/New/NewCategory.js